import React, { useContext, useEffect } from "react";
import TodoForm from "./TodoForm";
import { useState } from "react";
import { TodoContext } from "../context";
import moment from "moment";
import firebase from "../firebase";

export default function EditTodo() {
  // STATE
  // const [text, setText] = useState();
  const [text, setText] = useState("");
  // const [day, setDay] = useState();
  const [day, setDay] = useState(new Date());
  // const [time, setTime] = useState();
  const [time, setTime] = useState(new Date());
  // const [todoProject, setTodoProject] = useState();
  const [todoProject, setTodoProject] = useState("");
  // CONTEXT
  // selectedTodo
  const { selectedTodo, projects } = useContext(TodoContext);

  // CONTEXT'deki projexts i kullanacağız
  // const projects = [
  //   { id: 1, name: "personal", numOfTodos: 0 },
  //   { id: 2, name: "work", numOfTodos: 1 },
  //   { id: 3, name: "other", numOfTodos: 2 },
  // ];

  function handleSubmit(e) {
    console.log("handleSubmit");
  }

  //bu useEffect EditTodo daki alanları doldurur
  useEffect(() => {
    if (selectedTodo) {
      setText(selectedTodo.text);
      setDay(moment(selectedTodo.date, "MM/DD/YYYY"));
      setTime(moment(selectedTodo.time, "hh:mm A"));
      setTodoProject(selectedTodo.projectName);
    }
  }, [selectedTodo]);

  // bu useEffect firestore u update edecek
  useEffect(() => {
    if (selectedTodo) {
      firebase
        .firestore()
        .collection("todos")
        .doc(selectedTodo.id)
        .update({
          text,
          date: moment(day).format("MM/DD/YYYY"),
          day: moment(day).format("d"),
          time: moment(time).format("hh:mm A"),
          projectName: todoProject,
        });
    }
  }, [text, day, time, todoProject]);

  return (
    <div>
      {selectedTodo && (
        <div className="EditTodo">
          <div className="header">edit todo</div>
          <div className="container">
            <TodoForm
              handleSubmit={handleSubmit}
              text={text}
              setText={setText}
              day={day}
              setDay={setDay}
              time={time}
              setTime={setTime}
              projects={projects}
              todoProject={todoProject}
              setTodoProject={setTodoProject}
            />
          </div>
        </div>
      )}
    </div>
  );
}
